import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appIcons } from "../../../assets";
import AppLoader from "../../../components/apploader";
import NotificationCard from "../../../components/cards/NotificationCard";
import CustomContainer from "../../../components/container/CustomContainer";
import DashboardHeader from "../../../components/dashboardHeader";
import useNotifications from "../../../hooks/useNotifications";
import { t } from "i18next";

const UserNotificationPage = () => {
  const navigate = useNavigate();
  const { notificationsLoading, allNotifications, fetchAllNotifications } =
    useNotifications();
  const userData = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    if (userData) {
      fetchAllNotifications();
    }
  }, [userData]);

  return (
    <DashboardHeader>
      <AppLoader isVisible={notificationsLoading} />
      <CustomContainer
        primaryHeading={t("notification")}
        secondaryHeading={t("viewAllNotifications")}
        customIcom={<img src={appIcons.blackHeadphoneIcon} width={30} />}
        showBackButton={true}
        handleBack={() => navigate("/dashboard")}
      >
        <Grid container spacing={2}>
          {allNotifications.map((val, index) => {
            return (
              <Grid
                key={index}
                item
                xs={12}
                sm={6}
                md={4}
                style={{ display: "flex" }}
              >
                <NotificationCard data={val} index={index} />
              </Grid>
            );
          })}
        </Grid>
      </CustomContainer>
    </DashboardHeader>
  );
};

export default UserNotificationPage;
